module.exports = __webpack_public_path__ + "media/abk/assets/images/blank-a75db2c3e1deed40d807e8d2656674cd.png";